"use client"

import { useChatCountsStore } from "@/hooks/useChatCountStore"
import { NavItemBadge } from "./NavItemBadge"

export const MessagesBadge: React.FC = () => {
  const { unreadCount } = useChatCountsStore()

  if (unreadCount > 0) {
    return <NavItemBadge />
  }

  return null
}
